import React, { useEffect, useState } from 'react';
import { Card, Typography } from 'antd';
import moment from 'moment';
import { getAdminMarketplaceSubscriptions } from 'marketplace/apps/owner-reporting/api/marketplace';
import { MainContainer } from './MarketplaceActivations.styles';
import MarketplaceActivationsTable from './table/Table';

const { Title, Paragraph } = Typography;

const formatDate = value => (value ? moment(value).format('YYYY-MM-DD') : '-');

const MarketplaceActivations = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await getAdminMarketplaceSubscriptions();
        const rows = (Array.isArray(response) ? response : []).map(row => ({
          ...row,
          hostName: (row.host && row.host.name) || '-',
          productName: row.productName || row.productCode || '-',
          startedAtLabel: formatDate(row.startedAt),
          endedAtLabel: formatDate(row.endedAt)
        }));
        if (!cancelled) setData(rows);
      } catch (error) {
        console.error('Error fetching marketplace activations:', error);
        if (!cancelled) setData([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <MainContainer>
      <Title level={3} style={{ marginBottom: 8 }}>
        Marketplace activations
      </Title>
      <Paragraph type="secondary">Hosts that have activated marketplace products.</Paragraph>
      <Card>
        <MarketplaceActivationsTable data={data} loading={isLoading} />
      </Card>
    </MainContainer>
  );
};

export default MarketplaceActivations;
